export default __webpack_public_path__ + "static/media/step_C_UA.00e4a0e9.png";